import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { Breadcrumb, Button, Tabs, Tooltip } from 'antd';

import Table from 'components/Table';
import { elipsis } from 'shared/utils/StringUtil';

import { permissionService } from 'shared/services';
import { userPermissions, FILTER_TYPE, paginationParam } from 'shared/constant';

import NewFilter from 'components/NewFilter';
import text from './CompanyList.page.translation';

import organizationRoute from '../../route';

import './CompanyList.style.less';

import CompanyDetailsContainer from '../CompanyDetail/CompanyDetail.container';

const { TabPane } = Tabs;

const viewCompanyTabKey = 'view-company';
const viewAllTabKey = 'view-all';

export class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey: this.props.match.params.tab || viewCompanyTabKey,
    };

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    const { getAllModules, match, filterValue } = this.props;

    getAllModules();

    if (match.params.page) {
      this.updateCompanyTable(filterValue);
    } else {
      this.updateCompanyTable([]);
    }
  }

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (
      prevProps.match.params.page !== match.params.page ||
      prevProps.match.params.tab !== this.props.match.params.tab
    ) {
      this.updateCompanyTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else {
          this.updateCompanyTable(filterValue);
        }
      }
    }
  }

  _handleChangePage = page => {
    const { history } = this.props;

    const url = organizationRoute.COMPANY_LIST_FILTER.replace(
      ':tab',
      'view-all',
    ).replace(':page', page);
    history.push(url);
  };

  _renderNoColumn = (pageNum, pageSize) => (_text, _record, index) => {
    const result = index + 1 + pageSize * (pageNum - 1);
    return result;
  };

  _renderCompanyName = record => {
    const companyName = get(record, 'name', '');
    return (
      <button
        type="button"
        className="btn-details left-text"
        onClick={() => {
          this.props.history.push(
            organizationRoute.COMPANY_DETAIL.replace(':id', record.id),
          );
        }}
      >
        <Tooltip placement="topLeft" title={companyName}>
          <span>{elipsis(companyName, 30)}</span>
        </Tooltip>
      </button>
    );
  };

  _renderRoleColumn = record => {
    const { roles } = record;
    let companyRole = '-';
    if (get(roles, 'length')) {
      roles.forEach((role, index) => {
        if (index > 0) {
          companyRole += `, ${role.name}`;
        } else {
          companyRole = role.name;
        }
      });
    }

    return (
      <Tooltip title={companyRole}>
        <span>{elipsis(companyRole, 30)}</span>
      </Tooltip>
    );
  };

  _tableColumns = (pageNum, pageSize) => {
    const {
      intl: { formatMessage },
    } = this.props;
    return [
      {
        title: formatMessage(text.no),
        key: 'index',
        render: this._renderNoColumn(pageNum, pageSize),
        width: 100,
      },
      {
        title: formatMessage(text.companyName),
        render: this._renderCompanyName,
        key: 'name',
        width: 225,
      },
      {
        title: formatMessage(text.companyEmail),
        dataIndex: 'email',
        key: 'email',
        width: 300,
      },
      {
        title: formatMessage(text.companyRole),
        key: 'roles',
        render: this._renderRoleColumn,
        width: 300,
      },
      {
        title: formatMessage(text.companyId),
        dataIndex: 'id',
        key: 'id',
        width: 400,
      },
    ];
  };

  _getRowId = row => row.id;

  _renderBtnRegister = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Button
        type="primary"
        block
        className="btn register-vendor-btn"
        htmlType="submit"
      >
        <Link to={organizationRoute.COMPANY_REGISTER}>
          {formatMessage(text.btnRegister)}
        </Link>
      </Button>
    );
  };

  _renderCompanyDetails = () => {
    const { me } = this.props;
    const employeeId = me ? me.organization_details.organization_id : '';
    const disableBreadCrumb = true;

    if (employeeId) {
      return (
        <div className="list-company-details-container">
          <CompanyDetailsContainer
            disableBreadCrumb={disableBreadCrumb}
            employeeId={employeeId}
            {...this.props}
          />
        </div>
      );
    }
    return null;
  };

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  _renderTable = () => {
    const {
      listCompany,
      companyFilter,
      getCompanyListLoading,
      getAllModulesLoading,
    } = this.props;
    const pageSize = get(companyFilter, 'page_size');
    const pageCount = get(companyFilter, 'page_count');
    const pageNum = get(companyFilter, 'page_num');
    const totalItem = pageSize * pageCount;

    const loading = getCompanyListLoading || getAllModulesLoading;
    const tableColumns = this._tableColumns(pageNum, pageSize);
    const scrollX = this.getColumnsScrollX(tableColumns);

    return (
      <Table
        columns={tableColumns}
        dataSource={listCompany}
        bordered={false}
        pagination="true"
        rowKey={this._getRowId}
        rowClass="striped-table"
        loadingValue={loading}
        totalItem={totalItem}
        currentPage={pageNum}
        changePage={this._handleChangePage}
        scrollX={scrollX}
      />
    );
  };

  _renderFilter = () => {
    const {
      intl: { formatMessage },
      allModules,
    } = this.props;

    if (this.state.activeTabKey === viewAllTabKey) {
      const roleFilterOptions = allModules.map(x => ({
        value: x.name,
        label: x.name,
      }));

      const options = [
        {
          label: formatMessage(text.companyName),
          value: 'organization_name',
          type: FILTER_TYPE.TEXT,
        },
        {
          label: formatMessage(text.companyRole),
          value: 'role_name',
          type: FILTER_TYPE.RADIO,
          options: roleFilterOptions,
        },
      ];

      return <NewFilter options={options} />;
    }

    return null;
  };

  onChangeTab = activeKey => {
    this.setState(
      {
        activeTabKey: activeKey,
      },
      this.onChangeTabCallback,
    );
  };

  onChangeTabCallback = () => {
    this.props.resetFilter();

    let setURLtab;
    if (this.state.activeTabKey === viewCompanyTabKey) {
      setURLtab = viewCompanyTabKey;
    } else {
      setURLtab = viewAllTabKey;
    }

    this.props.history.push(
      organizationRoute.COMPANY_LIST_TAB.replace(':tab', setURLtab),
    );
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = companyFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(companyFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(companyFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(companyFilter.page_num)}`;

    return result;
  };

  updateCompanyTable = filterValue => {
    const {
      getListCompany,
      companyFilter,
      match,
      history,
      viewAll,
    } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';

    const canViewAll = get(viewAll, 'Organization', '');
    if (canViewAll) {
      // auto include view_all param
      paramUrl += '&view_all=true';
    }

    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl += this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...companyFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListCompany(paginationUrl, paramUrl);
      } else {
        history.push(organizationRoute.COMPANY_LIST);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListCompany(paginationUrl, paramUrl);
    }
  };

  render() {
    const {
      intl: { formatMessage },
      viewAll,
      getCompanyListLoading,
    } = this.props;

    const canViewAll = get(viewAll, 'Organization');
    const canCreateCompany = permissionService.checkPermission(
      userPermissions.CREATE_COMPANY,
      true,
    );

    return (
      <div className="main-content" id="company-list-container">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{formatMessage(text.companyList)}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <span className="title mbottom30">
            {formatMessage(text.companyList)}
          </span>

          {canCreateCompany && this._renderBtnRegister()}
          {this._renderFilter()}

          <div className="table-wrapper">
            <Tabs
              tabBarStyle={{ margin: '0px' }}
              type="card"
              onChange={this.onChangeTab}
              activeKey={this.state.activeTabKey}
            >
              <TabPane
                tab="View Company"
                disabled={getCompanyListLoading}
                key={viewCompanyTabKey}
              >
                {this._renderCompanyDetails()}
              </TabPane>
              {canViewAll ? (
                <TabPane
                  tab="View All"
                  disabled={getCompanyListLoading}
                  key={viewAllTabKey}
                >
                  {this._renderTable()}
                </TabPane>
              ) : null}
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

CompanyList.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  getListCompany: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  listCompany: PropTypes.array,
  allModules: PropTypes.array,
  getCompanyListLoading: PropTypes.bool,
  getAllModulesLoading: PropTypes.bool,
  getAllModules: PropTypes.func,
  me: PropTypes.object,
  viewAll: PropTypes.object,
  match: PropTypes.object,
  resetFilter: PropTypes.func,
  companyFilter: PropTypes.object,
  filterValue: PropTypes.array,
  formControlShow: PropTypes.bool,
};

export default CompanyList;
